._tooltip-paragraph_u5qr0_1 {
  padding-bottom: 6px; }
